import { FunctionComponent } from 'react';
import { Text } from '@mantine/core';
import { useKnowledgebase } from 'src/hooks/useKnowledgebase';
import { StyledContainer } from 'src/components/common/StyledComponents/Container';
import UploadDocs from 'src/components/UploadDocs';
import { ErrorMessage } from 'src/components/common/ErrorMessage/ErrorMessage';
import { StyledContainerInset } from 'src/components/common/StyledComponents/BackgroundContainer';
import { FONT_SIZES } from 'src/utils/styles';
import { KnowledgebaseFilesDrawer } from 'src/components/KnowledgebaseFilesDrawer';
import useResponsive from 'src/hooks/useResponsive';
import { useMultiFileUpload } from 'src/hooks/useFileUpload';
import { Notifications } from '@mantine/notifications';

const DocumentUploads: FunctionComponent = () => {
  const {
    getDocs,
    error,
    dismissError,
  } = useKnowledgebase(false);
  const {
    uploadStatuses,
    resetUploadStatuses,
  } = useMultiFileUpload();

  const { backgroundColor, backgroundColorExterior, isMobile } =
    useResponsive();

  return (
    <StyledContainer theme={{ backgroundColor: backgroundColorExterior }}>
      <StyledContainerInset theme={{ backgroundColor: backgroundColor }}>
        <Notifications
          position={isMobile ? 'top-center' : 'bottom-right'}
          limit={isMobile ? 1 : 5}
        />
        <div className='p-4 pb-20 mobile:pb-24 h-[100%] w-[100%] mobile:w-[100%] overflow-y-auto'>
          <ErrorMessage error={error} handleClose={dismissError} />
          <KnowledgebaseFilesDrawer
            onPressClose={resetUploadStatuses}
            files={uploadStatuses}
          />
          <Text size={FONT_SIZES.h1} fw={600}>
            Upload Documents
          </Text>
          <Text c='dimmed' size={14}>
            Modify assistant's core knowledge base.
          </Text>

          <UploadDocs
            onRefresh={getDocs}
          />
        </div>
      </StyledContainerInset>
    </StyledContainer>
  );
};

export default DocumentUploads;
